import React, { useEffect, useCallback, useRef } from 'react';
import { Theme, seismicTheme, Toasts, useToasts } from '@seismic/mantle';
import useColors from 'ui/hooks/useColors';

const TOAST_ID = 'scormProgressToast';

const LoadToast = () => {
  const timeoutRef = useRef(null);
  const { addToast, removeToast } = useToasts();

  const stopTimeout = useCallback(() => {
    if (timeoutRef.current) {
      removeToast(TOAST_ID);
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  }, [removeToast]);

  const getScormMessage = useCallback(
    event => {
      const { isTrusted, data } = event || {};

      if (!isTrusted || !data) return;

      if (data === 'Rustici:ContentLoaded') {
        stopTimeout();
      }
    },
    [stopTimeout],
  );

  useEffect(() => {
    addToast({
      id: TOAST_ID,
      content: t('questions.types.elearning.toast_content'),
      autoDismiss: false,
      variant: 'progress',
    });
  }, [addToast]);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      removeToast(TOAST_ID);
    }, 20_000);

    window.addEventListener('message', getScormMessage);

    return () => {
      stopTimeout();
      window.removeEventListener('message', getScormMessage);
    };
  }, [getScormMessage, stopTimeout, removeToast]);

  return <></>;
};

const ScormLoadingToast = () => {
  const { colorPrimary } = useColors();

  return (
    <Theme
      theme={seismicTheme({
        useGlobal: true,
        customization: {
          colors: {
            primary: colorPrimary,
          },
        },
      })}
    >
      <Toasts style={{ paddingBottom: '80px' }}>
        <LoadToast />
      </Toasts>
    </Theme>
  );
};

export default ScormLoadingToast;
